export const getCartInitialState = () => ({
    cartItems: [],
    cart: {},
    purchasedItems: [],
    purchased: {},
});
export const getProductsFromCartState = (state) => getProductsFromCart(state.cartItems, state.cart);
export const getProductsFromCartPurchasedState = (state) => getProductsFromCart(state.purchasedItems, state.purchased);
function getProductsFromCart(items, itemMap) {
    const productsMap = items.reduce((acc, key) => {
        const { productId, quantity } = itemMap[key];
        if (!(productId in acc)) {
            acc[productId] = {
                productId,
                quantity: 0,
            };
        }
        acc[productId].quantity += quantity;
        return acc;
    }, {});
    return [...Object.values(productsMap)];
}
